import { ref, Ref, watch } from 'vue';
import {
    B2CClientService,
    UpSellProduct,
    UpSellProductItemRelation,
} from '@/b2c/shared/api/server-apis';
import useBasket from '@/b2c/basket/useBasket';
import utilitiesService from '@/shared/utilities.service';

export const upSellItemsCancellationKey = 'upSellItemsCancellationKey';

const { basket, upSellItemCounter } = useBasket();
const items: Ref<(UpSellProductItemRelation | undefined)[]> = ref([] as UpSellProductItemRelation[]);
const fetchUpSellItems = async(): Promise<void> => {
    if (basket.value.basketId) {
        const response = await B2CClientService.getUpSellProducts(basket.value.basketId, upSellItemsCancellationKey).then(utilitiesService.unwrapModel);
        items.value = response ?? [] as UpSellProductItemRelation[];
    }
};

watch(upSellItemCounter, fetchUpSellItems, { immediate: true });

export function useUpSellItems() {
    const getProductsByItemId = (itemId: number): UpSellProduct[] => {
        const products = [] as UpSellProduct[];
        items.value.forEach((item) => {
            if (item && item.itemIds.indexOf(itemId) > -1) {
                products.push(item.product);
            }
        });
        return products;
    };

    return {
        items,
        getProductsByItemId,
    };
}
